import { CommonSvg } from "../SVG";

export const filterOptionData = {
  colors: [
    { id: "red", label: "Red", key: "red", value: "red" },
    { id: "green", label: "Green", key: "green", value: "green" },
    { id: "blue", label: "Blue", key: "blue", value: "blue" },
    { id: "yellow", label: "Yellow", key: "yellow", value: "yellow" },
    { id: "teal", label: "Teal", key: "teal", value: "teal" },
    { id: "purple", label: "Purple", key: "purple", value: "purple" },
    { id: "black", label: "Black", key: "black", value: "black" },
    {
      id: "lightblue",
      label: "Light Blue",
      key: "lightblue",
      value: "lightblue",
    },
    { id: "olive", label: "Olive", key: "olive", value: "olive" },
    { id: "brown", label: "Brown", key: "brown", value: "brown" },
    { id: "pink", label: "Pink", key: "pink", value: "pink" },
    { id: "orange", label: "Orange", key: "orange", value: "orange" },
    { id: "lime", label: "Lime", key: "lime", value: "lime" },
    { id: "cyan", label: "Cyan", key: "cyan", value: "cyan" },
    { id: "grey", label: "Grey", key: "grey", value: "grey" },
  ],
  faces: [
    {
      id: "single",
      name: "single",
      label: "single",
      asset: CommonSvg.singleIConSvg,
    },
    {
      id: "two",
      name: "Two",
      label: "Two",
      asset: CommonSvg.twoPeopleIconSvg,
    },
    {
      id: "group",
      name: "Group",
      label: "Group",
      asset: CommonSvg.groupIConSvg,
    },
  ],
  formats: [
    { id: 0, label: "Today" },
    { id: 7, label: "Last 7 days" },
    { id: 30, label: "Last 30 days" },
    { id: 90, label: "Last 90 days" },
    { id: 180, label: "Last 180 days" },
  ],
};

//src/Components/Common/Filters/Faces
